import React from "react";

/**
 * A small label, e.g. a device type's field name. The color lives here so
 * every tag in the app can be restyled in one place.
 *
 * Pass `onRemove` to get a × button.
 *
 * @param {{children: string, onRemove?: () => void}} props
 */
const Tag = ({children, onRemove}) => (
    <span
        className={
            "badge fw-medium bg-primary-subtle text-primary-emphasis border border-primary-subtle" +
            (onRemove ? " d-inline-flex align-items-center gap-1" : "")
        }
    >
        {children}
        {onRemove && (
            <button
                type="button"
                className="btn-close"
                style={{fontSize: "0.55em"}}
                aria-label={`Remover ${children}`}
                onClick={onRemove}
            />
        )}
    </span>
);

export default Tag;
